import { CountryCodes } from 'constants/Countries'

export const getIsFinpromCountry = (countryCode: string): boolean => {
  return countryCode === CountryCodes.UK
}
